import { ApiService } from "./api.service";
import { DOMAIN } from "./domain-constant";
export default class FolderService extends ApiService {
  namespace = "folder";
  icon = "FolderWithLabel";
  name = "Folder";
  favicon = "Folder";
  Width = 690;
  action = "action";
  DOMAIN = DOMAIN.FOLDERS;
  constructor() {
    super("folders");
  }

  getHierarchy(data) {
    return this.get(data, "hierarchy");
  }
}
